export default __webpack_public_path__ + "static/media/file-template.b2e0643f.svg";